module.exports = require('./lib/rijndael-block');
